import { IonContent, IonPage } from "@ionic/react";
import { withRouter } from "react-router";
import React from "react";
import Header from "src/components/Header";

import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { TextField } from "@material-ui/core";

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Denunciante } from "src/services/denuncias";

const Denuncias: React.FC = () => {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    button: {
      marginRight: theme.spacing(1),
    },
    buttonReiniciar: {
      color: '#980434',
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    textField: {
      margin: theme.spacing(3),
      width: '35ch',
      left: '25px',
      marginTop: '50px',
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: '95%',
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }));

  function getSteps() {
    return ['Motivo de su denuncia', 'Describe tu denuncia'];
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel htmlFor="outlined-native-simple">Motivo:</InputLabel>
            <Select
              native
              value={state.motivo}
              onChange={handleChange}
              label="Motivo"
              inputProps={{
                name: 'motivo',
                id: 'outlined-native-simple',
              }}
            >
              <option value={'Acoso'}>Acoso</option>
              <option value={'Coaccion'}>Violencia Contra la Mujer</option>
              <option value={'Maltrato'}>Maltrato</option>
              <option value={'Otro motivo'}>Otro motivo</option>
            </Select>
          </FormControl>
        );
      case 1:
        return (
          <form noValidate autoComplete="off">
            <TextField
              id="descripcion"
              value={state.comentario}
              onChange={handleTextoChange}
              className={classes.textField}
              aria-label="minimum height"
              placeholder="Describe tu denuncia aquí"
              multiline
              maxRows={2}
              inputProps={{
                name: 'descripcion',
                id: 'textAreaDenuncia',
              }}
              error={errorComentario} // Mostrar error si el comentario está vacío
              helperText={errorComentario ? 'Por favor, ingrese un comentario.' : ''}
            />
          </form>
        );
    }
  }

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const steps = getSteps();

  const [state, setState] = React.useState({
    motivo: 'Acoso', // Motivo predeterminado
    comentario: '',
  });

  const [errorComentario, setErrorComentario] = React.useState(false); // Estado para manejar errores del comentario

  const enviarSolicitud = (state) => {
    if (!state.motivo) {
      console.error('Debe seleccionar un motivo.');
      return;
    }

    if (!state.comentario || state.comentario.trim() === '') {
      setErrorComentario(true); // Mostrar mensaje de error si el comentario está vacío
      return;
    }

    setErrorComentario(false); // Limpiar errores si todo es válido

    Denunciante.Comentario(state)
      .then((response) => {
        console.log('Solicitud enviada exitosamente:', response);
        setActiveStep((prevActiveStep) => prevActiveStep + 1); // Avanzar al siguiente paso
      })
      .catch((error) => {
        console.error('Error al hacer la solicitud:', error);
      });
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    if (activeStep === steps.length - 1) {
      // Validar comentario antes de enviar
      enviarSolicitud(state);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };

  const handleTextoChange = (event) => {
    setState({ ...state, comentario: event.target.value });
    setErrorComentario(false); // Limpiar el error cuando el usuario escribe
  };

  return (
    <IonPage>
      <Header titulo="Denuncias" />
      <IonContent id="denuncias">
        <div className="container mb-3">
          <div className="d-flex justify-content-center">
            <figure>
              <figcaption>
                <cite>SU DENUNCIA ES ANÓNIMA</cite>
              </figcaption>

              <blockquote>
                <p className="mt-1 mb-0">
                  Consideramos todas sus denuncias a través de este canal, por favor
                  no dude en comunicarnos si usted está atravesando una situación difícil.
                </p>
              </blockquote>
            </figure>
          </div>

          <div className="d-flex justify-content-center">
            <figure>
              <figcaption>
                <cite>Motivo de la denuncia</cite>
              </figcaption>
              <div className={classes.root}>
                <Stepper activeStep={activeStep}>
                  {steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    return (
                      <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
                <div>
                  {activeStep === steps.length ? (
                    <div>
                      <Typography className={classes.instructions}>
                        Su denuncia ha sido enviada exitosamente. Será verificada y tratada por nuestro comité de ética.
                        Agradecemos su confianza y trabajaremos para mejorar el entorno de trabajo.
                      </Typography>
                      <Button onClick={handleReset} className={classes.buttonReiniciar}>
                        Reiniciar
                      </Button>
                    </div>
                  ) : (
                    <div>
                      <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                      <div>
                        <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                          Atrás
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleNext}
                          className={classes.button}
                        >
                          {activeStep === steps.length - 1 ? 'Enviar' : 'Siguiente'}
                        </Button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </figure>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default withRouter(Denuncias);
